import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53b0f42a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ResetPassword connection" }
const _hoisted_2 = { class: "connection__left" }
const _hoisted_3 = { class: "connection__right" }
const _hoisted_4 = {
  key: 0,
  class: "connection__content"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["type"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_11 = ["type"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 17" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-form-eye" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 20 20" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L19 19",
    stroke: "black",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_16 = { class: "connection__footer" }
const _hoisted_17 = { class: "connection__menu" }
const _hoisted_18 = {
  key: 0,
  class: "error-msg error-msg--center"
}
const _hoisted_19 = {
  key: 1,
  class: "connection__content"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "connection__instructions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyPicture = _resolveComponent("LazyPicture")!
  const _component_AppearObject = _resolveComponent("AppearObject")!
  const _component_ButtonClose = _resolveComponent("ButtonClose")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ButtonSave = _resolveComponent("ButtonSave")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_LayoutConnected = _resolveComponent("LayoutConnected")!

  return (_openBlock(), _createBlock(_component_LayoutConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_AppearObject, { class: "connection__background" }, {
            default: _withCtx(() => [
              _createVNode(_component_LazyPicture, {
                image: { url: '/images/connection/reset.jpg', double: {url: '/images/connection/reset@2x.jpg' }},
                class: "picture picture--full",
                lazy: false
              }, null, 8, ["image"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("header", null, [
            _createVNode(_component_ButtonClose, {
              class: "connection__close",
              to: "/",
              variant: "dark"
            }),
            _createVNode(_component_Logo, { class: "connection__logo" })
          ]),
          (_ctx.step == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_AppearObject, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h1", null, [
                      _createVNode(_component_LineByLine, {
                        innerHTML: _ctx.$t('resetPassword.title')
                      }, null, 8, ["innerHTML"])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("form", {
                  class: "connection__form form",
                  onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
                  novalidate: ""
                }, [
                  _createElementVNode("p", {
                    class: "connection__instructions",
                    innerHTML: _ctx.$t('resetPassword.instructions')
                  }, null, 8, _hoisted_5),
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('resetPassword.new_password')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.new_password) = $event)),
                      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.new_password.$touch && _ctx.v$.new_password.$touch(...args))),
                      class: _normalizeClass({ 'error': _ctx.v$.new_password.$errors.length }),
                      type: _ctx.isPasswordObscurated ? 'password' : 'text',
                      name: "new_password",
                      minlength: "8",
                      required: "",
                      autocomplete: "off",
                      spellcheck: "false",
                      autocapitalize: "off",
                      autocorrect: "off"
                    }, null, 42, _hoisted_6), [
                      [_vModelDynamic, _ctx.new_password]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass([{ 'active': _ctx.isPasswordObscurated }, "form__hide"]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPasswordObscurated = !_ctx.isPasswordObscurated)),
                      tabindex: "-1"
                    }, _hoisted_9, 2),
                    (_ctx.v$.new_password.$errors.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.v$.new_password.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("legend", null, _toDisplayString(_ctx.$t('resetPassword.confirm_new_password')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirm_new_password) = $event)),
                      onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.confirm_new_password.$touch && _ctx.v$.confirm_new_password.$touch(...args))),
                      class: _normalizeClass({ 'error': _ctx.v$.confirm_new_password.$errors.length }),
                      type: _ctx.isPasswordObscurated ? 'password' : 'text',
                      name: "confirm_new_password",
                      minlength: "8",
                      required: "",
                      autocomplete: "off",
                      spellcheck: "false",
                      autocapitalize: "off",
                      autocorrect: "off"
                    }, null, 42, _hoisted_11), [
                      [_vModelDynamic, _ctx.confirm_new_password]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass([{ 'active': _ctx.isPasswordObscurated }, "form__hide"]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isPasswordObscurated = !_ctx.isPasswordObscurated)),
                      tabindex: "-1"
                    }, _hoisted_14, 2),
                    (_ctx.v$.confirm_new_password.$errors.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.v$.confirm_new_password.$errors[0].$message), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.token) = $event)),
                    type: "hidden",
                    name: "token"
                  }, null, 512), [
                    [_vModelText, _ctx.token]
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_router_link, { to: "/login" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('resetPassword.login')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_ButtonSave, {
                      saved: _ctx.sended,
                      loading: _ctx.loading,
                      type: "submit",
                      class: "button"
                    }, {
                      saved: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('resetPassword.saved')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('resetPassword.save')) + " ", 1)
                      ]),
                      _: 1
                    }, 8, ["saved", "loading"])
                  ]),
                  (_ctx.errorMessage !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true)
                ], 32)
              ]))
            : _createCommentVNode("", true),
          (_ctx.step == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_AppearObject, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h1", null, [
                      _createVNode(_component_LineByLine, {
                        innerHTML: _ctx.$t('resetPassword.success_title')
                      }, null, 8, ["innerHTML"])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("p", {
                  class: "connection__instructions",
                  innerHTML: _ctx.$t('resetPassword.success_message')
                }, null, 8, _hoisted_20),
                _createElementVNode("p", _hoisted_21, [
                  _createVNode(_component_ButtonHover, {
                    class: "button",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('resetPassword.login')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_BackButton, {
          class: "connection__back",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('resetPassword.back')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}